import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Stack } from "@mui/material";
import { forwardRef, useRef, useMemo, memo } from "react";
import "../../Button/Button.js";
import "../../InputControl/InputControl.js";
import "../../InputControl/Input/InputBase.js";
import "../../PhoneInputControl/PhoneInputControl.js";
import "../../PhoneInputControl/PhoneInput/PhoneInput.js";
import "../../IconButton/IconButton.js";
import "../../common/ControlBody.js";
import "../../SelectControl/Select/context/SelectContext.js";
import "../../Dialog/Dialog.js";
import { IconButton } from "../../IconButtonNew/IconButton.js";
import "../../../icons/24/Action/Close.js";
import "../../../icons/24/Arrow/ChevronLeft.js";
import { inheritDataTestId } from "../../../utils/dataTestId.js";
import "../../SelectControl/Select/components/SelectInput/SelectInput.js";
import "../../SelectControl/Select/MultiSelect/context/MultiSelectContext.js";
import "../../../icons/24/System/Check.js";
import { ChevronDownIcon } from "../../../icons/24/Arrow/ChevronDown.js";
import "../../TextareaControl/TextareaControl.js";
import "../../SearchControl/SearchControl.js";
import "../../../icons/24/System/Search.js";
import "../../FormattedPhone/FormattedPhoneNumber.js";
import "../../Avatar/styles.js";
import { Checkbox } from "../../CheckboxGroup/Checkbox/Checkbox.js";
import "../../CheckboxGroup/styles.js";
import "../../RadioGroup/Radio/styles.js";
import "../../RadioGroup/styles.js";
import "../../RatingButton/styles.js";
import "../../FloatingActionButton/styles.js";
import "../../SortingButton/styles.js";
import "../../SquareButton/styles.js";
import "../../Toggle/styles.js";
import "../../Dialog/StyledDialog.js";
import "../../Chips/Chip/styles.js";
import "../../ResultMarksNumber/styles.js";
import "../../Progress/ProgressCircle/styles.js";
import "../../Loaders/LoaderCircle/styles.js";
import "../../Loaders/LoaderLine/styles.js";
import "../../SegmentedControl/styles.js";
import "../../ResultMarksText/styles.js";
import "../../Link/styles.js";
import "../../Tag/Tag.js";
import "../../DatePicker/constants.js";
import "../../DatePicker/components/RangePicker/context/DateRangePickerContext.js";
import "../../DatePicker/components/RangePicker/context/DateRangePickerContextActions.js";
import "../../DatePicker/shared/fragments/CalendarCell/CalendarCell.js";
import "../../../external/classnames/index.js";
import "../../Scrollbar/Scrollbar.js";
import "../../DatePicker/shared/fragments/MonthYearSelector/YearSelector.js";
import "../../DatePicker/components/DatePicker/context/DatePickerContext.js";
import "../../DatePicker/components/DatePicker/context/DatePickerContextActions.js";
import "../../MobileBottomSheet/MobileBottomSheet.js";
import { ListItem } from "../ListItem/ListItem.js";
import "../../Nowrap.js";
import { Label } from "./components/Label.js";
const heights = { xs: 42, lg: 36 }, ListItemTree_ = forwardRef(
  (props, ref) => {
    const {
      level,
      hasChildren,
      match,
      label,
      expanded,
      id,
      onExpand,
      checkboxId,
      ...restProps
    } = props, onExpandRef = useRef(onExpand);
    onExpandRef.current = onExpand;
    const startAdornment = useMemo(() => /* @__PURE__ */ jsx(
      IconButton,
      {
        color: "quaternary",
        size: "xs",
        onClick: () => {
          var _a;
          return (_a = onExpandRef.current) == null ? void 0 : _a.call(onExpandRef, !expanded, props.name);
        },
        sx: props.disabled ? { color: "grey.400" } : void 0,
        "data-test-id": inheritDataTestId(
          { "data-test-id": props["data-test-id"] },
          "expand-icon"
        ),
        children: hasChildren && /* @__PURE__ */ jsx(
          Box,
          {
            component: ChevronDownIcon,
            sx: expanded ? styles.expanded : styles.collapsed
          }
        )
      }
    ), [
      expanded,
      hasChildren,
      props.disabled,
      props.name,
      props["data-test-id"]
    ]);
    return /* @__PURE__ */ jsx(
      ListItem,
      {
        sx: { paddingLeft: { sm: level * 30 + 12, xs: level * 15 + 12 } },
        startAdornment,
        ref,
        id,
        "data-test-id": props["data-test-id"],
        children: /* @__PURE__ */ jsxs(Stack, { direction: "row", children: [
          /* @__PURE__ */ jsx(
            Checkbox,
            {
              sx: styles.checkboxAdditional,
              ...restProps,
              id: checkboxId,
              "data-test-id": inheritDataTestId(props, "checkbox")
            }
          ),
          /* @__PURE__ */ jsx(
            Label,
            {
              label,
              match,
              lines: hasChildren ? 1 : 4,
              disabled: props.disabled,
              htmlFor: checkboxId,
              "data-test-id": inheritDataTestId(props, "label")
            }
          )
        ] })
      }
    );
  }
), TreeListItem = memo(ListItemTree_), styles = {
  checkboxAdditional: {
    ".MuiCheckbox-root": { marginRight: 12 }
  },
  parentCheckboxRow: {
    alignItems: "center",
    minHeight: heights,
    paddingLeft: 12
  },
  expanded: {},
  collapsed: {
    rotate: "-90deg"
  },
  childBox: {
    paddingLeft: 30
  },
  btnContainer: {
    width: 36,
    height: 36,
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",
    marginRight: 7
  },
  btnContainerPadding: { paddingLeft: { xs: 10, sm: 20 } }
};
export {
  TreeListItem
};
//# sourceMappingURL=TreeListItem.js.map
